export { PriceCard } from './PriceCard'
export { PriceCardPsihologiyaIsHigherEducation } from './PriceCardPsihologiyaIsHigherEducation'
